import { render, staticRenderFns } from "./DrawerStatusLabel.vue?vue&type=template&id=6f0a4b9b"
import script from "./DrawerStatusLabel.vue?vue&type=script&lang=js"
export * from "./DrawerStatusLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports